export const CATALOG_PATH_SEGMENTS = [
  'challenge',
  'collection',
  'person',
  'explore',
  'topic',
  'watchlist',
] as const;
